import { BUSINESS_MODELS } from "@shared/constants";

export function getDealCeeSubsidy(deal) {
  if (!deal || !deal?.currentDeal?.isCEESubsidySelected) {
    return { enabled: false };
  }

  const isB2BSelected = deal?.businessModel === BUSINESS_MODELS.B2B;
  const ceeSubsidyType = deal?.currentDeal?.isCEESubsidySelected;

  let base =
    deal.configuration?.app?.solJourney ||
    deal.currentDeal?.configuration?.app?.solJourney;

  if (isB2BSelected) {
    return base?.b2b?.cashJourney?.ceeSubsidy?.[ceeSubsidyType];
  }

  return base?.cashJourney?.ceeSubsidy?.[ceeSubsidyType];
}
